import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { PrivacyPolicyPage } from './privacy-policy/privacy-policy.component';
import { TermsAndConditionsPage } from './terms-and-conditions/terms-and-conditions.component';
import { CorporatePolicyPage } from './corporate-policy/corporate-policy.component';
import { RenamePage } from './rename/rename.component';
import { MobileReferralPage } from './nmconnect/mobile-referral.component';

@NgModule({
    declarations: [
        PrivacyPolicyPage,
        TermsAndConditionsPage,
        CorporatePolicyPage,
        RenamePage,
        MobileReferralPage,
    ],
    imports: [FormsModule, RouterModule],
    exports: [
        PrivacyPolicyPage,
        TermsAndConditionsPage,
        CorporatePolicyPage,
        RenamePage,
        MobileReferralPage,
    ],
    providers: [],
})
export class StaticPagesModule {}
